export const logout = () => {
  localStorage.clear();
  sessionStorage.clear(); // clear storage
  window.open(process.env.REACT_APP_API_URL + "/auth/logout", "_self");
};
